import { definePreset } from '../types/portal-settings';

// The support portal is its own product: one ticket list, no booking surface.
export default definePreset({
	homePage: 'support',
	pages: ['support', 'settings'],
	features: {
		twoFactorAuth: false,
		supportJobs: {
			enabled: true,
			fromDateDefault: 'lastWeek',
			toDateDefault: 'today',
			allowJobView: true,
			allowJobDetailsView: true,
			allowJobCreate: true,
			allowJobEdit: true,
		},
	},
});
